import { logDev } from "@agtech/core/logging/AgTechLogger";
import { AgTechGridControlProps } from "../Data/AgTechGridProps";
import { useState, useEffect, useRef } from "react";

export const AgTechGridNumberControl = (props: React.PropsWithChildren<AgTechGridControlProps<number>>) => {
    let [controlValue, setControlValue] = useState(props.value);
    let lastValue = useRef(props.value);

    useEffect(() => {
        if (props.value !== controlValue) {
            setControlValue(props.value);
            lastValue.current = props.value;
        }
    }, [props.value]);

    return (
        <div className="stretched p-0 border-0 bg-transparent outline-none max-w-[100%] flex">
            <input
                className="stretched py-1 px-3 text-sm bg-transparent outline-none focus:border flex"
                type="number"
                value={controlValue}
                readOnly={props.readonly}
                onChange={e => setControlValue(e.currentTarget.valueAsNumber) }
                onKeyDown={e => {
                    if (e.key === 'Enter' && props.onUpdated) {
                        props.onUpdated(controlValue);
                    }
                }}
                onBlur={e => {
                    if (props.onUpdated && (controlValue !== lastValue.current) && !(Number.isNaN(controlValue) && Number.isNaN(lastValue.current))) {
                        logDev('[AgTechGridNumberControl]: Value updated', { oldValue: lastValue.current, newValue: controlValue });

                        lastValue.current = controlValue;
                        props.onUpdated(controlValue);
                    } 
                }}
                tabIndex={props.readonly ? -1 : 0}
            />
        </div>
    )
}